/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
} from './PersonHandle';

/**
 * 
 * @export
 * @interface Authentication
 */
export interface Authentication {
    /**
     * 
     * @type {PersonHandle}
     * @memberof Authentication
     */
    handle: PersonHandle;
    /**
     * RFC3339 timestamp
     * @type {Date}
     * @memberof Authentication
     */
    timestamp: Date;
    /**
     * 
     * @type {FactorMethod}
     * @memberof Authentication
     */
    method: FactorMethod;
}

/**
 * Check if a given object implements the Authentication interface.
 */
export function instanceOfAuthentication(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "handle" in value;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "method" in value;

    return isInstance;
}

export function AuthenticationFromJSON(json: any): Authentication {
    return AuthenticationFromJSONTyped(json, false);
}

export function AuthenticationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Authentication {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'handle': PersonHandleFromJSON(json['handle']),
        'timestamp': (new Date(json['timestamp'])),
        'method': FactorMethodFromJSON(json['method']),
    };
}

export function AuthenticationToJSON(value?: Authentication | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'handle': PersonHandleToJSON(value.handle),
        'timestamp': (value.timestamp.toISOString()),
        'method': FactorMethodToJSON(value.method),
    };
}

